'use strict'

const types = {
  SET_TILE: 'SET_TILE',
}

export default types



// WEBPACK FOOTER //
// ./_src/riot/store/types.js